/**
 * Route -> tenant feature_code mapping (white-label entitlement gating).
 *
 * Single source of truth used by BOTH the sidebar menu filter (App.vue) and the
 * router guard (router/index.js). Returns the coarse feature_code a route belongs
 * to, or null when the route is not gated (always allowed).
 *
 * IMPORTANT: this only HIDES/BLOCKS routes when the tenant has
 * entitlements_enforced=1 AND the feature is disabled. For every normal/legacy
 * domain the backend returns ALL features, so hasFeature() is always true and
 * nothing changes. Unknown routes -> null -> allowed.
 *
 * Most specific prefix wins (list is sorted by prefix length at module load).
 */
const RAW_MAP = [
  // Voice robots (settings area) — must come before the generic /settings note
  ['/settings/voice-robots', 'voice_robots'],
  ['/settings/voice-control-center', 'voice_robots'],
  ['/settings/phone-agent', 'voice_robots'],
  ['/settings/voice-analytics', 'voice_robots'],
  ['/settings/voice-history', 'voice_robots'],
  ['/settings/voice-conversations', 'voice_robots'],
  // Widgets
  ['/settings/widget-labs', 'widgets'],
  ['/widgets', 'widgets'],
  // Branding / appearance
  ['/appearance', 'branding'],
  ['/settings/branding', 'branding'],
  // Presets
  ['/settings/presets', 'presets'],
  ['/presets', 'presets'],
  // Customer portal (admin side)
  ['/settings/customer-portal', 'customer_portal'],
  ['/portal', 'customer_portal'],
  // Integrations
  ['/settings/integrations', 'integrations'],
  // Sales & CRM + Marketing (sidebar groups)
  ['/crm', 'crm'],
  ['/sales', 'sales'],
  // Contact center
  ['/call-center', 'dialer'],
  ['/chat', 'dialer'],
  // Field service / jobs
  ['/jobs', 'jobs'],
  ['/dispatch', 'jobs'],
  ['/production', 'jobs'],
  // Inventory & parts
  ['/operations', 'parts'],
  // Finance
  ['/accounting', 'accounting'],
  // People / HR
  ['/hr', 'hr'],
  // Insights & planning
  ['/reports', 'reports'],
  ['/planning', 'reports'],
  ['/pulse', 'reports'],
  // Marketing
  ['/marketing', 'marketing'],
  // E-signature
  ['/esign', 'esign'],
]

const FEATURE_MAP = [...RAW_MAP].sort((a, b) => b[0].length - a[0].length)

export function routeToFeature(path) {
  if (!path) return null
  for (const [prefix, feature] of FEATURE_MAP) {
    if (path === prefix || path.startsWith(prefix + '/') || path.startsWith(prefix + '?')) {
      return feature
    }
  }
  return null
}
